import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';
import Typography from '@mui/material/Typography';
import { Box, Stack } from '@mui/material';
import { IPieChartPanel } from '../Dashboard.model';

interface PieChartPanelProps {
  panel: IPieChartPanel;
}
export default function PieChartPanel(props: PieChartPanelProps) {
  const { panel } = props;
  const { title, subtitle } = panel;
  return (
    <>
      <Stack direction="column" alignItems="flex-start" width={'100%'}>
        <Typography variant="body1" fontWeight={800} fontSize={'0.8em'}>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary" fontSize={'0.6em'}>
          {subtitle}
        </Typography>
      </Stack>
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        width={'100%'}
        height={'100%'}
      >
        <Typography
          variant="h3"
          component="div"
          sx={{ fontWeight: 'bold', marginX: 2 }}
        >
          {panel.series.reduce(
            (acc, item) => acc + item.data.reduce((sum, d) => sum + d.value, 0),
            0
          )}
        </Typography>
        <Box
          sx={{
            flexGrow: 1,
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
          }}
        >
          <PieChart
            series={panel.series}
            sx={{ aspectRatio: 3 }}
            height={80}
            margin={0}
            slotProps={{
              legend: {
                direction: 'horizontal',
                position: {
                  vertical: 'bottom',
                  horizontal: 'center',
                },
              },
            }}
          />
        </Box>
      </Stack>
    </>
  );
}
